import config from '../config.js'
import { ref} from "vue"
import {eonUserState} from '@/composable/eonUserState'

/**
 * Laden des Json und aufbereiten der Produktdaten, Filter, Sortierung, Übersetzung, Marken
 * @param cfg
 * @returns {{brands: Ref<UnwrapRef<{}>>, GlassesList: Ref<UnwrapRef<*[]>>, sorting: Ref<UnwrapRef<{}>>, translation: Ref<UnwrapRef<{}>>, filters: Ref<UnwrapRef<{}>>, fetchGlasses: fetchGlasses}}
 */
export function fetchJsonObject(cfg) {
    const {getEonUserstate} = eonUserState()
    let GlassesList = ref([])
    let filters = ref({})
    let sorting = ref({})
    let translation = ref({})
    let brands = ref({})
    let lastResponse = ref({
        list: config.jsonUrl
    })
    fetchGlasses(cfg)

    /**
     * presets aus der Elementconfig oder dem UserState (im Sessionstore) auslesen
     * @param cfg - übergebene config aus dem Element-Data-Attributen
     * @param filters - filter aus dem Json
     * @returns {*}
     */
    function doPresets(cfg, filters) {

        const eonFiltersFromState = getEonUserstate('eonFilters') ? JSON.parse(getEonUserstate('eonFilters')) : false;
        // Vorgecheckte Filter oder Slider aus dem Userstate nehmen, falls vorhanden
        // Andernfalls Presets in der Config verwenden
        const checkFilters = eonFiltersFromState ? eonFiltersFromState : JSON.parse(cfg['checkFilters']).shift()
        if(typeof checkFilters == 'object') {
            for (const [key, value] of Object.entries(checkFilters)) {
                // queries muss immer ein Array enthalten
                filters[key].queries = (typeof value == 'string') ? [value] : value
            }
        }
        return filters
    }
    /**
     * Json abholen und Datenobjekte bereitstellen
     * @param cfg
     */
    function fetchGlasses(cfg) {
        fetch(lastResponse.value.list)
            .then(response => response.json())
            .then(data => {
                GlassesList.value.push(...data.itemlist)
                filters.value = doPresets(cfg, data.filters)
                translation.value = data.translation
                sorting.value = data.sorting
                brands.value = data.brands
            })

    }
    return {
        GlassesList,
        fetchGlasses,
        filters,
        translation,
        sorting,
        brands
    }
}